<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-form ref="form" v-model="frmValid" class="pa-3">
        <v-container fluid grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="txtUserId"
                :rules="[v => !!v || 'User Id is required']"
                label="User Id"
                :disabled="(paymentId && paymentId.length > 0) || (salesOrderNo && salesOrderNo.length > 0)"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="userName"
                label="Name"
                :disabled="true"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="userLoginEmail"
                label="Email"
                :disabled="true"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="txtSalesOrderNo"
                label="Sales Order No"
                :disabled="(paymentId && paymentId.length > 0) || (salesOrderNo && salesOrderNo.length > 0)"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select
                v-model="cboMethod"
                :rules="[v => !!v || 'Please choose payment method']"
                v-bind:items="methods"
                item-text="paymentMethodName"
                item-value="paymentMethodId"
                label="Payment Method"
                :disabled="paymentId !== '' && paymentId !== undefined"
                @change="selectMethod($event)"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 v-if="cboMethod.substr(0, 12) === 'BANKTRANSFER'">
              <v-text-field
                v-model="txtTTSenderName"
                :rules="[v => !!v || 'Sender name is required', v => (v && v.length > 2) || 'Sender name must be 2 characters or more']"
                label="Sender Name"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod.substr(0, 12) === 'BANKTRANSFER'">
              <v-text-field
                v-model="txtTTSenderBank"
                :rules="[v => !!v || 'Sender bank is required', v => (v && v.length > 2) || 'Sender bank must be 2 characters or more']"
                label="Sender Bank"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod.substr(0, 12) === 'BANKTRANSFER'">
              <v-select
                v-model="cboTTReceiverBank"
                :rules="[v => !!v || 'Please choose receiving bank']"
                v-bind:items="receiverBanks"
                item-text="bankDescription"
                item-value="bankIdAccountNo"
                label="Receiving Bank"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 v-if="cboMethod.substr(0, 12) === 'BANKTRANSFER'">
              <v-text-field
                v-model="txtTTRefNo"
                label="Reference No"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'CASH'">
              <v-text-field
                v-model="txtCashReceivedBy"
                :rules="[v => !!v || 'Cash receiver is required', v => (v && v.length > 2) || 'Cash receiver must be 2 characters or more']"
                label="Cash received by"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'WESTERNUNION'">
              <v-text-field
                v-model="txtWUMTCNNo"
                :rules="[v => !!v || 'MTCN no is required', v => (v && v.length === 10) || 'Must be 10 characters']"
                :counter="10"
                label="MTCN No"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'WESTERNUNION'">
              <v-text-field
                v-model="txtWUSenderFirstName"
                :rules="[v => !!v || 'Sender first name is required', v => (v && v.length > 2) || 'Sender first name must be 2 characters or more']"
                label="Sender First Name"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'WESTERNUNION'">
              <v-text-field
                v-model="txtWUSenderLastName"
                :rules="[v => !!v || 'Sender last name is required', v => (v && v.length > 2) || 'Sender last name must be 2 characters or more']"
                label="Sender Last Name"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'MONEYGRAM'">
              <v-text-field
                v-model="txtMGReferenceNo"
                :rules="[v => !!v || 'Moneygram Ref no is required', v => (v && v.length === 8) || 'Must be 8 characters']"
                :counter="8"
                label="Moneygram Ref No"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'MONEYGRAM'">
              <v-text-field
                v-model="txtMGSenderFirstName"
                :rules="[v => !!v || 'Sender first name is required', v => (v && v.length > 2) || 'Sender first name must be 2 characters or more']"
                label="Sender First Name"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'MONEYGRAM'">
              <v-text-field
                v-model="txtMGSenderLastName"
                :rules="[v => !!v || 'Sender last name is required', v => (v && v.length > 2) || 'Sender last name must be 2 characters or more']"
                label="Sender Last Name"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'OCEAN'">
              <v-text-field
                v-model="txtOceanPaymentId"
                :rules="[v => !!v || 'Ocean payment Id is required', v => (v && v.length > 2) || 'Ocean payment Id must be 2 characters or more']"
                label="Ocean Payment Id"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'OCEAN'">
              <v-text-field
                v-model="txtOceanCardNo"
                :rules="[v => !!v || 'Ocean Card No is required', v => (v && v.length > 2) || 'Ocean Card No must be 2 characters or more']"
                label="Ocean Card No"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'OCEAN'">
              <v-text-field
                v-model="txtOceanPaymentCountry"
                :rules="[v => !!v || 'Ocean payment Country is required']"
                label="Ocean Payment Country"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'OCEAN'">
              <v-text-field
                v-model="txtOceanPaymentStatus"
                :rules="[v => !!v || 'Ocean payment status is required']"
                label="Ocean Payment Status"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'OCEAN'">
              <v-text-field
                v-model="txtOceanPaymentDetails"
                :rules="[v => !!v || 'Ocean payment details is required', v => (v && v.length > 2) || 'Ocean payment details must be 2 characters or more']"
                label="Ocean Payment Details"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'OCEAN'">
              <v-textarea
                v-model="txtOceanRawResponse"
                label="Raw Response"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'PAYPAL'">
              <v-text-field
                v-model="txtPpTxnId"
                :rules="[v => !!v || 'Paypal TxnId is required']"
                label="Paypal TxnId"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'PAYPAL'">
              <v-text-field
                v-model="txtPpTxnType"
                :rules="[v => !!v || 'Paypal TxnType is required']"
                label="Paypal TxnType"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'PAYPAL'">
              <v-text-field
                v-model="txtPpPayerEmail"
                :rules="[v => !!v || 'Paypal payer email is required']"
                label="Paypal payer email"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'PAYPAL'">
              <v-text-field
                v-model="txtPpReceiverEmail"
                :rules="[v => !!v || 'Paypal receiver email is required']"
                label="Paypal receiver email"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'PAYPAL'">
              <v-text-field
                v-model="txtPpPaymentType"
                :rules="[v => !!v || 'Paypal payment type is required']"
                label="Paypal payment type"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'PAYPAL'">
              <v-text-field
                v-model="txtPpPaymentStatus"
                :rules="[v => !!v || 'Paypal payment status is required']"
                label="Paypal payment status"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'PAYPAL'">
              <v-text-field
                v-model="txtPpPendingReason"
                label="Paypal pending reason"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'PAYPAL'">
              <v-text-field
                v-model="txtPpReasonCode"
                label="Paypal reason code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'PAYPAL'">
              <v-textarea
                v-model="txtPpRawResponse"
                label="Raw Response"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'COINBASE'">
              <v-text-field
                v-model="txtCoinbaseChargeCode"
                label="Coinbase Charge Code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'COINBASE'">
              <v-text-field
                v-model="txtCoinbaseStatus"
                label="Coinbase Status"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'COINBASE'">
              <v-text-field
                v-model="txtCoinbaseCurrency"
                label="Coinbase Currency"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'COINBASE'">
              <v-text-field
                v-model="txtCoinbaseAmount"
                label="Coinbase Amount"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'COINBASE'">
              <v-textarea
                v-model="txtCoinbaseRawResponse"
                label="Coinbase Raw Response"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'TAZAPAY'">
              <v-text-field
                v-model="txtTazapayTxnNo"
                label="Tazapay Txn No"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'TAZAPAY'">
              <v-text-field
                v-model="txtTazapayRedirectUrl"
                label="Tazapay Redirect Url"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'TAZAPAY'">
              <v-text-field
                v-model="txtTazapayState"
                label="Tazapay State"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'TAZAPAY'">
              <v-text-field
                v-model="txtTazapaySubState"
                label="Tazapay Sub State"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'TAZAPAY'">
              <v-text-field
                v-model="txtTazapayCurrency"
                label="Tazapay Currency"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'TAZAPAY'">
              <v-text-field
                v-model="txtTazapayAmount"
                label="Tazapay Amount"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'TAZAPAY'">
              <v-textarea
                v-model="txtTazapayRawRequest"
                label="Tazapay Raw Request"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'TAZAPAY'">
              <v-textarea
                v-model="txtTazapayRawResponse"
                label="Tazapay Raw Response"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'COINPAYMENTS'">
              <v-text-field
                v-model="txtCoinTxnId"
                label="Coin TxnId"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'COINPAYMENTS'">
              <v-text-field
                v-model="txtCoinStatus"
                label="Coin Status"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'COINPAYMENTS'">
              <v-text-field
                v-model="txtCoinStatusText"
                label="Coin Status Text"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'COINPAYMENTS'">
              <v-text-field
                v-model="txtCoinCurrency"
                label="Coin Currency"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'COINPAYMENTS'">
              <v-text-field
                v-model="txtCoinAmount"
                label="Coin Amount"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'COINPAYMENTS'">
              <v-textarea
                v-model="txtCoinRawResponse"
                label="Coin Raw Response"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'BITCOIN'">
              <v-text-field
                v-model="txtBtcAmount"
                label="Bitcoin Amount"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'BITCOIN'">
              <v-text-field
                v-model="txtBtcTransactionId"
                label="Bitcoin Transaction Id"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'BITCOIN'">
              <v-text-field
                v-model="txtBtcSenderAddress"
                label="Bitcoin Sender Address"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'USDT'">
              <v-select
                v-model="cboUsdtType"
                :rules="[v => !!v || 'Please choose type']"
                v-bind:items="usdtTypes"
                label="Type"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'USDT'">
              <v-text-field
                v-model="txtUsdtAmount"
                label="USDT Amount"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'USDT'">
              <v-text-field
                v-model="txtUsdtTransactionId"
                label="USDT Transaction Hash Id"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'USDT'">
              <v-text-field
                v-model="txtUsdtSenderAddress"
                label="USDT Sender Address"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'BINANCE-FORM'">
              <v-text-field
                v-model="txtBinanceOrderId"
                label="Binance Order Id"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'BINANCE-FORM'">
              <v-text-field
                v-model="txtBinanceSenderName"
                label="Binance Sender Name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'ALIPAY'">
              <v-text-field
                v-model="txtAlipayTransId"
                label="Alipay Trans Id"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'WECHATPAY'">
              <v-text-field
                v-model="txtWechatpayTransId"
                label="WechatPay Trans Id"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'PAYTM'">
              <v-text-field
                v-model="txtPaytmTransId"
                label="PayTM Trans Id"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'PHONEPE'">
              <v-text-field
                v-model="txtPhonepeTransId"
                label="PhonePe Trans Id"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cboMethod === 'THIRDPARTY'">
              <v-text-field
                v-model="txtThirdPartyName"
                label="3rd Party Name"
              ></v-text-field>
            </v-flex>
            <v-flex xs2 sm1>
              <v-select
                v-model="cboCurrencyCode"
                :rules="[v => !!v || 'Please choose currency']"
                v-bind:items="currencies"
                item-text="currencyCode"
                item-value="currencyCode"
                label="Currency"
                :disabled="paymentId != '' && paymentId !== undefined"
                @change="clickCurrencyDropdown($event)"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 sm7>
              <v-text-field
                v-model="txtAmount"
                :rules="[v => !!v || 'Invalid amount', v => (v && v > 0) || 'Amount must be > 0']"
                label="Amount"
                type="number"
                :disabled="paymentId != '' && paymentId !== undefined"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm2>
              <v-text-field
                v-model="txtFeeAmount"
                :label="(txtFeeAmount >= 0 ? 'Fee' : 'Discount')"
                type="number"
                :disabled="paymentId != '' && paymentId !== undefined"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm2>
              <v-text-field
                v-model="txtAmountAfterFee"
                label="Transfer Amount"
                type="number"
                :disabled="true"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="txtExchangeRateToBase"
                :rules="[v => v > 0 || 'Exchange rate must be more than 0']"
                label="Exchange Rate to USD"
                type="number"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="txtRemark"
                label="Remarks"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select
                v-if="paymentId"
                v-model="cboStatus"
                :items="statuses"
                label="Payment status"
                :disabled="true"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 class="mt-4" v-if="paymentId.length === 0">
              <div class="font-weight-bold">UPLOAD FILES</div>
              <v-list v-if="fileUploads.length > 0" style="background-color:transparent;">
                <template v-for="(file, fileIndex) in fileUploads">
                  <v-list-tile
                    :key="fileIndex"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title class="body-2">
                        {{ file.name }}
                        <v-btn
                          icon
                          small
                          class="ml-2 mr-0 mt-0 mb-0"
                          @click="removeFileUpload(fileIndex)"
                        >
                          <v-icon small>close</v-icon>
                        </v-btn>
                        <span v-if="file.uploadStatus && file.uploadStatus === 'success'" class="green--text ml-3">
                          <v-icon small color="green" class="mr-1">done</v-icon>
                          Uploaded
                        </span>
                        <span v-if="file.uploadStatus && file.uploadStatus === 'uploading'" class="orange--text ml-3">
                          <v-icon small color="orange" class="mr-1">hourglass_empty</v-icon>
                          Uploading
                        </span>
                        <span v-if="file.uploadStatus && file.uploadStatus === 'error'" class="red--text ml-3">
                          <v-icon small color="red" class="mr-1">close</v-icon>
                          Upload failed
                        </span>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
              <input
                type="file"
                multiple
                style="display: none"
                ref="filePicker"
                accept="*"
                @change="onFilePicked"
                @click="$refs.filePicker.value = null"
              >
              <div>
                <span v-if="fileUploads.length === 0" class="grey--text">No file uploaded</span>
                <v-btn
                  outline
                  small
                  v-if="fileUploads.length < 3"
                  @click="pickFile"
                >
                  Add file
                </v-btn>
              </div>
            </v-flex>
            <v-flex xs12 v-else>
              <div class="font-weight-bold">UPLOADED FILES</div>
              <v-list style="background-color:transparent;">
                <template v-for="(file, fileIndex) in payment.files">
                  <v-list-tile :key="fileIndex">
                    <v-list-tile-content>
                      <v-list-tile-title class="body-2">
                        <a :href="file.url" class="white--text">{{ file.fileName }}</a>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
            </v-flex>
            <v-flex xs12>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmValid"
                @click="submit"
              >
                Save
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import router from '../router'
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import uniq from 'lodash/uniq'

export default {
  props: {
    salesOrderNo: {
      type: String,
      default: '',
      required: false
    },
    paymentId: {
      type: String,
      default: '',
      required: false
    }
  },
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      frmValid: false,
      pageTitle: '',
      salesOrder: {},
      currencies: [],
      cboCurrencyCode: 'USD',
      currencySign: '',
      currencyDecimals: 0,
      currencyDecimalSign: '',
      txtUserId: '',
      userName: '',
      userLoginEmail: '',
      txtSalesOrderNo: this.salesOrderNo,
      cboMethod: '',
      payment: {},
      methods: [],
      receiverBanks: [],
      txtTTSenderName: '',
      txtTTSenderBank: '',
      cboTTReceiverBank: null,
      txtTTRefNo: '',
      txtCashReceivedBy: '',
      txtWUMTCNNo: '',
      txtWUSenderFirstName: '',
      txtWUSenderLastName: '',
      txtMGReferenceNo: '',
      txtMGSenderFirstName: '',
      txtMGSenderLastName: '',
      txtOceanPaymentId: '',
      txtOceanCardNo: '',
      txtOceanPaymentCountry: '',
      txtOceanPaymentStatus: '',
      txtOceanPaymentDetails: '',
      txtOceanRawResponse: '',
      txtPpTxnId: '',
      txtPpTxnType: '',
      txtPpPayerEmail: '',
      txtPpReceiverEmail: '',
      txtPpPaymentType: '',
      txtPpPaymentStatus: '',
      txtPpPendingReason: '',
      txtPpReasonCode: '',
      txtPpRawResponse: '',
      txtCoinbaseChargeCode: '',
      txtCoinbaseStatus: '',
      txtCoinbaseCurrency: '',
      txtCoinbaseAmount: '',
      txtCoinbaseRawResponse: '',
      txtTazapayTxnNo: '',
      txtTazapayRedirectUrl: '',
      txtTazapayState: '',
      txtTazapaySubState: '',
      txtTazapayCurrency: '',
      txtTazapayAmount: '',
      txtTazapayRawRequest: '',
      txtTazapayRawResponse: '',
      txtCoinTxnId: '',
      txtCoinStatus: '',
      txtCoinStatusText: '',
      txtCoinCurrency: '',
      txtCoinAmount: '',
      txtCoinRawResponse: '',
      txtBtcAmount: 0,
      txtBtcTransactionId: '',
      txtBtcSenderAddress: '',
      usdtTypes: ['TRC20', 'ERC20'],
      cboUsdtType: '',
      txtUsdtAmount: 0,
      txtUsdtTransactionId: '',
      txtUsdtSenderAddress: '',
      txtBinanceOrderId: '',
      txtBinanceSenderName: '',
      txtAlipayTransId: '',
      txtWechatpayTransId: '',
      txtPaytmTransId: '',
      txtThirdPartyName: '',
      cboStatus: '',
      statuses: ['pending', 'confirmed', 'rejected', 'chargeback', 'incomplete'],
      fileUploads: [],
      txtRemark: '',
      txtAmount: 0,
      txtFeeAmount: 0,
      txtAmountAfterFee: 0,
      txtExchangeRateToBase: 1
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getCurrencies()
    this.getPaymentMethods()
    this.getSalesOrderDetails()
  },

  watch: {
    txtAmount (newAmount, oldAmount) {
      this.txtAmountAfterFee = parseFloat(newAmount) + parseFloat(this.txtFeeAmount)
    },
    txtFeeAmount (newFee, oldFee) {
      this.txtAmountAfterFee = parseFloat(this.txtAmount) + parseFloat(newFee)
    }
  },

  methods: {
    pickFile: function () {
      this.$refs.filePicker.click()
    },
    onFilePicked: function (e) {
      const files = e.target.files
      console.log(files)

      if (files.length + this.fileUploads.length > 3) {
        window.alert('You can only upload maximum of 3 files')
        return false
      }

      for (let i = 0; i < files.length; i++) {
        if (typeof files[i] === 'object') {
          if (files[i].name.lastIndexOf('.') <= 0) {
            return
          }

          const fr = new FileReader()
          fr.readAsDataURL(files[i])
          var _this = this
          fr.addEventListener('load', () => {
            _this.fileUploads.push({
              name: files[i].name,
              url: fr.result,
              file: files[i]
            })
          })
        }
      }
    },
    removeFileUpload: function (fileIndex) {
      this.fileUploads.splice(fileIndex, 1)
    },
    selectMethod: function (methodId) {
      for (var i in this.methods) {
        if (this.methods[i].paymentMethodId === methodId) {
          this.receiverBanks = this.methods[i].bankAccounts
          break
        }
      }
    },
    clickCurrencyDropdown: function (currencyCode) {
      console.log('clickCurrencyDropdown: ' + currencyCode)
      for (var i in this.currencies) {
        if (this.currencies[i].currencyCode === currencyCode) {
          console.log('((' + this.salesOrder.cacheTotalSalesInBase + ' + ' + this.salesOrder.deliveryCostInBase + ' + ' + this.salesOrder.importTariffInBase + ') - (' + this.salesOrder.cacheTotalPaymentInBase + ' + ' + this.salesOrder.cacheTotalVoucherDiscountInBase + ')) / ' + this.currencies[i].exchangeRateToBase + ')')
          var amount = ((this.salesOrder.cacheTotalSalesInBase + this.salesOrder.deliveryCostInBase + this.salesOrder.importTariffInBase) - (this.salesOrder.cacheTotalPaymentInBase + this.salesOrder.cacheTotalVoucherDiscountInBase)) / this.currencies[i].exchangeRateToBase
          amount = this.formatPrice(amount, this.currencies[i].decimals + 2)
          this.txtAmount = amount.replace(/,/g, '')
          this.txtExchangeRateToBase = this.currencies[i].exchangeRateToBase
          break
        }
      }
    },
    initPage: function () {
      var _this = this
      if (_this.paymentId !== '' && _this.paymentId !== undefined) {
        _this.pageTitle = 'Edit Payment - ' + _this.paymentId
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/payment/' + _this.paymentId)
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.payment = resp.data.data
              _this.txtUserId = resp.data.data.userId
              _this.userName = resp.data.data.title + ' ' + resp.data.data.firstName + ' ' + resp.data.data.lastName
              _this.userLoginEmail = resp.data.data.loginEmail
              if (resp.data.data.salesOrderNos.length > 0) {
                _this.txtSalesOrderNo = resp.data.data.salesOrderNos[0].salesOrderNo
              }
              _this.cboMethod = resp.data.data.paymentMethodId
              _this.selectMethod(_this.cboMethod)
              if (_this.cboMethod.substr(0, 12) === 'BANKTRANSFER') {
                _this.txtTTSenderName = resp.data.data.ttSenderName
                _this.txtTTSenderBank = resp.data.data.ttSenderBankName
                _this.cboTTReceiverBank = resp.data.data.ttDestinationBankId + '|' + resp.data.data.ttDestinationBankAccountNo
                _this.txtTTRefNo = resp.data.data.ttRefNo
              } else if (_this.cboMethod === 'CASH') {
                _this.txtCashReceivedBy = resp.data.data.cashReceivedBy
              } else if (_this.cboMethod === 'MONEYGRAM') {
                _this.txtMGReferenceNo = resp.data.data.mgReferenceNo
                _this.txtMGSenderFirstName = resp.data.data.mgSenderFirstName
                _this.txtMGSenderLastName = resp.data.data.mgSenderLastName
              } else if (_this.cboMethod === 'WESTERNUNION') {
                _this.txtWUMTCNNo = resp.data.data.wuMTCNNo
                _this.txtWUSenderFirstName = resp.data.data.wuSenderFirstName
                _this.txtWUSenderLastName = resp.data.data.wuSenderLastName
              } else if (_this.cboMethod === 'OCEAN') {
                _this.txtOceanPaymentId = resp.data.data.oceanPaymentId
                _this.txtOceanCardNo = resp.data.data.oceanCardNo
                _this.txtOceanPaymentCountry = resp.data.data.oceanPaymentCountry
                _this.txtOceanPaymentStatus = resp.data.data.oceanPaymentStatus
                _this.txtOceanPaymentDetails = resp.data.data.oceanPaymentDetails
                _this.txtOceanRawResponse = resp.data.data.oceanRawResponse
              } else if (_this.cboMethod === 'PAYPAL') {
                _this.txtPpTxnId = resp.data.data.ppTxnId
                _this.txtPpTxnType = resp.data.data.ppTxnType
                _this.txtPpPayerEmail = resp.data.data.ppPayerEmail
                _this.txtPpReceiverEmail = resp.data.data.ppReceiverEmail
                _this.txtPpPaymentType = resp.data.data.ppPaymentType
                _this.txtPpPaymentStatus = resp.data.data.ppPaymentStatus
                _this.txtPpPendingReason = resp.data.data.ppPendingReason
                _this.txtPpReasonCode = resp.data.data.ppReasonCode
                _this.txtPpRawResponse = resp.data.data.ppRawResponse
              } else if (_this.cboMethod === 'COINBASE') {
                _this.txtCoinbaseChargeCode = resp.data.data.coinbaseChargeCode
                _this.txtCoinbaseStatus = resp.data.data.coinbaseStatus
                _this.txtCoinbaseCurrency = resp.data.data.coinbaseCurrency
                _this.txtCoinbaseAmount = resp.data.data.coinbaseAmount
                _this.txtCoinbaseRawResponse = resp.data.data.coinbaseRawResponse
              } else if (_this.cboMethod === 'TAZAPAY') {
                _this.txtTazapayTxnNo = resp.data.data.tazapayTxnNo
                _this.txtTazapayRedirectUrl = resp.data.data.tazapayRedirectUrl
                _this.txtTazapayState = resp.data.data.tazapayState
                _this.txtTazapaySubState = resp.data.data.tazapaySubState
                _this.txtTazapayCurrency = resp.data.data.tazapayCurrency
                _this.txtTazapayAmount = resp.data.data.tazapayAmount
                _this.txtTazapayRawRequest = resp.data.data.tazapayRawRequest
                _this.txtTazapayRawResponse = resp.data.data.tazapayRawResponse
              } else if (_this.cboMethod === 'COINPAYMENTS') {
                _this.txtCoinTxnId = resp.data.data.coinTxnId
                _this.txtCoinStatus = resp.data.data.coinStatus
                _this.txtCoinStatusText = resp.data.data.coinStatusText
                _this.txtCoinCurrency = resp.data.data.coinCurrency
                _this.txtCoinAmount = resp.data.data.coinAmount
                _this.txtCoinRawResponse = resp.data.data.coinRawResponse
              } else if (_this.cboMethod === 'BITCOIN') {
                _this.txtBtcAmount = resp.data.data.btcAmount
                _this.txtBtcTransactionId = resp.data.data.btcTransactionId
                _this.txtBtcSenderAddress = resp.data.data.btcSenderAddress
              } else if (_this.cboMethod === 'USDT') {
                _this.cboUsdtType = resp.data.data.usdtType
                _this.txtUsdtAmount = resp.data.data.usdtAmount
                _this.txtUsdtTransactionId = resp.data.data.usdtTransactionId
                _this.txtUsdtSenderAddress = resp.data.data.usdtSenderAddress
              } else if (_this.cboMethod === 'BINANCE-FORM') {
                _this.txtBinanceOrderId = resp.data.data.binanceOrderId
                _this.txtBinanceSenderName = resp.data.data.binanceSenderName
              } else if (_this.cboMethod === 'ALIPAY') {
                _this.txtAlipayTransId = resp.data.data.alipayTransId
              } else if (_this.cboMethod === 'WECHATPAY') {
                _this.txtWechatpayTransId = resp.data.data.wechatpayTransId
              } else if (_this.cboMethod === 'PAYTM') {
                _this.txtPaytmTransId = resp.data.data.paytmTransId
              } else if (_this.cboMethod === 'PHONEPE') {
                _this.txtPhonepeTransId = resp.data.data.phonepeTransId
              } else if (_this.cboMethod === 'THIRDPARTY') {
                _this.txtThirdPartyName = resp.data.data.thirdPartyName
              }

              _this.cboCurrencyCode = resp.data.data.currencyCode
              _this.currencySign = resp.data.data.currencySign
              _this.currencyDecimals = resp.data.data.currencyDecimals
              _this.currencyDecimalSign = resp.data.data.currencyDecimalSign
              _this.cboStatus = resp.data.data.status
              _this.txtRemark = resp.data.data.remarks
              _this.txtAmount = resp.data.data.amount
              _this.txtFeeAmount = resp.data.data.feeAmount
              _this.txtAmountAfterFee = _this.txtAmount + _this.txtFeeAmount
              _this.txtExchangeRateToBase = resp.data.data.exchangeRateToBase
            } else {
              console.log('unable to load sales order payment details: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            _this.loading = false
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
            }
          })
      } else {
        _this.pageTitle = 'Add Payment'
      }
    },
    getSalesOrderDetails: function () {
      var _this = this
      if (_this.salesOrderNo && _this.salesOrderNo.length > 0) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/sales/' + _this.salesOrderNo)
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.salesOrder = resp.data.data
              _this.txtUserId = resp.data.data.userId
              _this.userName = resp.data.data.billingTitle + ' ' + resp.data.data.billingFirstName + ' ' + resp.data.data.billingLastName
              _this.userLoginEmail = resp.data.data.loginEmail
              _this.currencySign = resp.data.data.currencySign
              _this.currencyDecimals = resp.data.data.currencyDecimals
              _this.currencyDecimalSign = resp.data.data.currencyDecimalSign
              _this.cboCurrencyCode = resp.data.data.currencyCode
              _this.getCurrencies()
            } else {
              console.log('unable to load sales order details: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            _this.loading = false
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
            }
          })
      }
    },
    getCurrencies: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/currencies')
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            for (var i in resp.data.data) {
              if (_this.salesOrder && _this.salesOrder.salesOrderNo) {
                // use order's rate
                if (resp.data.data[i].currencyCode === _this.salesOrder.currencyCode) {
                  resp.data.data[i].exchangeRateToBase = _this.salesOrder.exchangeRateToBase
                }
              }
            }

            _this.currencies = resp.data.data
            if (_this.paymentId === '') {
              _this.clickCurrencyDropdown(_this.cboCurrencyCode)
            }
          } else {
            console.log('unable to load currencies: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    getPaymentMethods: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/payment/methods')
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            for (var c = 0; c < resp.data.data.length; ++c) {
              if (resp.data.data[c].paymentMethodId.substr(0, 12) === 'BANKTRANSFER') {
                for (var d = 0; d < resp.data.data[c].bankAccounts.length; ++d) {
                  resp.data.data[c].bankAccounts[d].bankDescription = resp.data.data[c].bankAccounts[d].bankName.concat(
                    ' Account No: ', resp.data.data[c].bankAccounts[d].bankAccountNo,
                    ' Name: ', resp.data.data[c].bankAccounts[d].bankAccountName)
                  resp.data.data[c].bankAccounts[d].bankIdAccountNo = resp.data.data[c].bankAccounts[d].bankId + '|' + resp.data.data[c].bankAccounts[d].bankAccountNo
                }
              }
            }
            _this.methods = resp.data.data
            _this.initPage()
          } else {
            console.log('unable to payment methods: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          _this.loading = false
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
          }
        })
    },
    submit: function () {
      var _this = this
      if (_this.$refs.form.validate()) {
        _this.loading = true

        // inject files
        var i, j
        var isUploadFile = false
        var formData = new FormData()
        for (i in _this.fileUploads) {
          if (typeof _this.fileUploads[i].uploadStatus === 'undefined' || _this.fileUploads[i].uploadStatus !== 'success') {
            formData.append('file' + (parseInt(i) + 1), _this.fileUploads[i].file, _this.fileUploads[i].name)
            _this.fileUploads[i].uploadStatus = 'uploading'
            isUploadFile = true
          }
        }

        if (isUploadFile) {
          // upload files
          axios.post(process.env.VUE_APP_API_ROOT + '/v1/payment/file', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then(resp => {
              console.log(resp.data)
              if (resp.data.status === 'success') {
                var errorCount = 0
                for (i = 1; i <= 3; i++) {
                  if (typeof resp.data.data['file' + i] !== 'undefined' && typeof resp.data.data['file' + i].paymentFileId !== 'undefined') {
                    for (j in _this.fileUploads) {
                      if (resp.data.data['file' + i].fileName === _this.fileUploads[j].name) {
                        if (typeof resp.data.data['file' + i].paymentFileId !== 'undefined') {
                          _this.fileUploads[j].paymentFileId = resp.data.data['file' + i].paymentFileId
                          _this.fileUploads[j].uploadStatus = 'success'
                        } else {
                          _this.fileUploads[j].uploadStatus = 'error'
                          errorCount++
                        }
                        break
                      }
                    }
                  }
                }

                // only continue if all upload success
                if (errorCount === 0) {
                  _this.submitPayment()
                } else {
                  window.alert(errorCount + ' of the file upload failed, please retry')
                }
              } else {
                window.alert(resp.data.message)
              }
              _this.loading = false
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                }
                _this.loading = false
              }
            })
        } else {
          _this.submitPayment()
        }
      }
    },
    submitPayment () {
      console.log('submitPayment')
      var _this = this
      if (_this.$refs.form.validate()) {
        // Native form submission is not yet supported
        var objPayment = {}
        if (_this.txtSalesOrderNo && _this.txtSalesOrderNo.length > 0) {
          objPayment.salesOrderNos = [_this.txtSalesOrderNo]
        }
        objPayment.paymentMethodId = _this.cboMethod
        objPayment.userId = _this.txtUserId
        objPayment.currencyCode = _this.cboCurrencyCode
        objPayment.amount = _this.txtAmount
        objPayment.feeAmount = _this.txtFeeAmount
        objPayment.exchangeRateToBase = _this.txtExchangeRateToBase
        objPayment.remarks = _this.txtRemark

        if (_this.cboMethod.substr(0, 12) === 'BANKTRANSFER') {
          var keyArray = uniq(_this.cboTTReceiverBank.split('|'))
          var bankId = keyArray[0].trim()
          var accountNo = keyArray[1].trim()
          for (var c = 0; c < _this.receiverBanks.length; ++c) {
            if (_this.receiverBanks[c].bankId === bankId && _this.receiverBanks[c].bankAccountNo === accountNo) {
              objPayment.ttDestinationBankId = _this.receiverBanks[c].bankId
              objPayment.ttDestinationBankAccountNo = _this.receiverBanks[c].bankAccountNo
              objPayment.ttDestinationBankAccountName = _this.receiverBanks[c].bankAccountName
              break
            }
          }
          objPayment.ttSenderName = _this.txtTTSenderName
          objPayment.ttSenderBankName = _this.txtTTSenderBank
          objPayment.ttRefNo = _this.txtTTRefNo
        } else if (_this.cboMethod === 'CASH') {
          objPayment.cashReceivedBy = _this.txtCashReceivedBy
        } else if (_this.cboMethod === 'MONEYGRAM') {
          objPayment.mgReferenceNo = _this.txtMGReferenceNo
          objPayment.mgSenderFirstName = _this.txtMGSenderFirstName
          objPayment.mgSenderLastName = _this.txtMGSenderLastName
        } else if (_this.cboMethod === 'WESTERNUNION') {
          objPayment.wuMTCNNo = _this.txtWUMTCNNo
          objPayment.wuSenderFirstName = _this.txtWUSenderFirstName
          objPayment.wuSenderLastName = _this.txtWUSenderLastName
        } else if (_this.cboMethod === 'OCEAN') {
          objPayment.oceanPaymentId = _this.txtOceanPaymentId
          objPayment.oceanCardNo = _this.txtOceanCardNo
          objPayment.oceanPaymentCountry = _this.txtOceanPaymentCountry
          objPayment.oceanPaymentStatus = _this.txtOceanPaymentStatus
          objPayment.oceanPaymentDetails = _this.txtOceanPaymentDetails
          objPayment.oceanRawResponse = _this.txtOceanRawResponse
        } else if (_this.cboMethod === 'PAYPAL') {
          objPayment.ppTxnId = _this.txtPpTxnId
          objPayment.ppTxnType = _this.txtPpTxnType
          objPayment.ppPayerEmail = _this.txtPpPayerEmail
          objPayment.ppReceiverEmail = _this.txtPpReceiverEmail
          objPayment.ppPaymentType = _this.txtPpPaymentType
          objPayment.ppPaymentStatus = _this.txtPpPaymentStatus
          objPayment.ppPendingReason = _this.txtPpPendingReason
          objPayment.ppReasonCode = _this.txtPpReasonCode
          objPayment.ppRawResponse = _this.txtPpRawResponse
        } else if (_this.cboMethod === 'COINBASE') {
          objPayment.coinbaseChargeCode = _this.txtCoinbaseChargeCode
          objPayment.coinbaseStatus = _this.txtCoinbaseStatus
          objPayment.coinbaseCurrency = _this.txtCoinbaseCurrency
          objPayment.coinbaseAmount = _this.txtCoinbaseAmount
          objPayment.coinbaseRawResponse = _this.txtCoinbaseRawResponse
        } else if (_this.cboMethod === 'TAZAPAY') {
          objPayment.tazapayTxnNo = _this.txtTazapayTxnNo
          objPayment.tazapayRedirectUrl = _this.txtTazapayRedirectUrl
          objPayment.tazapayState = _this.txtTazapayState
          objPayment.tazapaySubState = _this.txtTazapaySubState
          objPayment.tazapayCurrency = _this.txtTazapayCurrency
          objPayment.tazapayAmount = _this.txtTazapayAmount
          objPayment.tazapayRawRequest = _this.txtTazapayRawRequest
          objPayment.tazapayRawResponse = _this.txtTazapayRawResponse
        } else if (_this.cboMethod === 'COINPAYMENTS') {
          objPayment.coinTxnId = _this.txtCoinTxnId
          objPayment.coinStatus = _this.txtCoinStatus
          objPayment.coinStatusText = _this.txtCoinStatusText
          objPayment.coinCurrency = _this.txtCoinCurrency
          objPayment.coinAmount = _this.txtCoinAmount
          objPayment.coinRawResponse = _this.txtCoinRawResponse
        } else if (_this.cboMethod === 'BITCOIN') {
          objPayment.btcAmount = _this.txtBtcAmount
          objPayment.btcTransactionId = _this.txtBtcTransactionId
          objPayment.btcSenderAddress = _this.txtBtcSenderAddress
        } else if (_this.cboMethod === 'USDT') {
          objPayment.usdtType = _this.cboUsdtType
          objPayment.usdtAmount = _this.txtUsdtAmount
          objPayment.usdtTransactionId = _this.txtUsdtTransactionId
          objPayment.usdtSenderAddress = _this.txtUsdtSenderAddress
        } else if (_this.cboMethod === 'BINANCE-FORM') {
          objPayment.binanceOrderId = _this.txtBinanceOrderId
          objPayment.binanceSenderName = _this.txtBinanceSenderName
        } else if (_this.cboMethod === 'ALIPAY') {
          objPayment.alipayTransId = _this.txtAlipayTransId
        } else if (_this.cboMethod === 'WECHATPAY') {
          objPayment.wechatpayTransId = _this.txtWechatpayTransId
        } else if (_this.cboMethod === 'THIRDPARTY') {
          objPayment.thirdPartyName = _this.txtThirdPartyName
        }

        // Update payment
        if (_this.paymentId) {
          _this.loading = true
          axios.put(process.env.VUE_APP_API_ROOT + '/v1/payment/' + _this.paymentId, objPayment, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              _this.loading = false
              if (resp.data.status === 'success') {
                alert('Payment updated')
                router.go(-1)
              } else {
                window.alert(resp.data.message)
              }
            })
            .catch(function (error) {
              _this.loading = false
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                }
              }
            })
        } else {
          // New payment
          _this.loading = true

          // inject files
          if (_this.fileUploads.length > 0) {
            var fileIds = []
            for (var i in _this.fileUploads) {
              fileIds.push(_this.fileUploads[i].paymentFileId)
            }
            objPayment.fileIds = fileIds
          }

          axios.post(process.env.VUE_APP_API_ROOT + '/v1/payment', objPayment, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              _this.loading = false
              if (resp.data.status === 'success') {
                alert('Payment added')
                if (_this.salesOrderNo) {
                  router.go(-1)
                } else {
                  var isConfirmPayment = false
                  for (var i in _this.profile.permissions) {
                    if (_this.profile.permissions[i].permissionId === 'PEM-PAYMENT') {
                      if (_this.profile.permissions[i].isConfirm === '1') {
                        isConfirmPayment = true
                      }
                      break
                    }
                  }

                  if (isConfirmPayment === true) {
                    router.push('/payments/confirmed')
                  } else {
                    router.push('/payments')
                  }
                }
              } else {
                window.alert(resp.data.message)
              }
            })
            .catch(function (error) {
              _this.loading = false
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                }
              }
            })
        }
      }
    }
  }
}
</script>
